type ProxyStatusSnapshot = {
  isRunning?: boolean;
  port?: number | null;
  httpsPort?: number | null;
};

export async function readProxyStatusSafely(): Promise<
  ProxyStatusSnapshot | undefined
> {
  if (typeof window === 'undefined' || !window.electronAPI) {
    return undefined;
  }

  try {
    return await window.electronAPI.proxy.getStatus();
  } catch (error: unknown) {
    console.warn('Failed to read proxy status', {
      error: error instanceof Error ? error : new Error(String(error)),
    });
    return undefined;
  }
}
